var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouthG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 21,
    viewBox: "0 0 34 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 1.37484e-06C7.61116 5.54037e-07 6.8015e-07 4.21999 0 12L34 12C34 4.21999 26.3888 2.19563e-06 17 1.37484e-06Z",
    fill: "#DE9079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 21C24.203 21 31 17.835 31 12L3 12C3 17.835 10.672 21 17.4375 21Z",
    fill: "#F0B493"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthG);
export default __webpack_public_path__ + "static/media/Mouth G.155267d280c86552ed35e401d0325295.svg";
export { ForwardRef as ReactComponent };